import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function CareerSkeleton() {
    return (
        <>
            <Skeleton height={128} borderRadius={20} />
            <Skeleton height={128} borderRadius={20} className="mt-2" />
            <Skeleton height={128} borderRadius={20} className="mt-2" />
        </>
    );
}
